<template lang="pug">
modal(id="edit-grid", ref="modal")
    template(slot="title") Update Grid Layout
    template(slot="footer")
        button.btn.btn-fw.primary(type="button" @click="submit" :disabled="onLoading('create-order-layout')")
            v-loading(loader="create-order-layout") Save
    template(slot="body")
        form(@submit.prevent="submit")
            fieldset
                .row
                    .col-md-12
                        .form-group
                            label Name
                            input.form-control(type="text", v-model="name", name="name", v-validate="'required'")
                            span.text-danger.block(v-show="errors.has('name')") {{ errors.first('name') }}

                    .col-md-12
                        .form-group
                            label Description
                            textarea.form-control(row="3", v-model="description", name="description")

                    .col-md-12
                        p Grid Size

                    .col-md-6
                        .form-group
                            label Width
                            input.form-control(type="text", v-model="width", v-validate="'required|integer|min_value:2|max_value:7'", name="width")
                            span.text-danger.block(v-show="errors.has('width')") {{ errors.first('width') }}
        
                    .col-md-6
                        .form-group
                            label Height
                            input.form-control(type="text", v-model="height", v-validate="'required|integer|min_value:2|max_value:10'", name="height")
                            span.text-danger.block(v-show="errors.has('height')") {{ errors.first('height') }}
</template>

<script>
import { OrderLayoutEvent } from './order-layout-bus';
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            name: null,
            description: null,
            width: null,
            height: null,
        };
    },

    computed: {
        ...mapGetters('orderLayout', ['orderLayout']),
    },

    mounted() {
        OrderLayoutEvent.$on('edit-grid', () => {
            if (this.onLoading('fetch-order-layout')) return;

            this.name = this.orderLayout.name;
            this.description = this.orderLayout.description;
            this.height = this.orderLayout.height;
            this.width = this.orderLayout.width;

            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        ...mapActions('orderLayout', ['setOrderLayoutAttribute']),

        async submit() {
            const validate = await this.$validator.validateAll();

            if (!validate) return;

            // if update grid to smaller size show warning
            if (
                this.width < this.orderLayout.width ||
                this.height < this.orderLayout.height
            ) {
                const { value } = await swal({
                    title: 'Are you sure?',
                    text: 'Reducing grid size might delete some cell',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#fff',
                    cancelButtonClass: 'text-dark',
                    confirmButtonText: 'Yes',
                });

                if (_.isNil(value)) return;
            }

            this.updateOrderLayout('name', this.name);
            this.updateOrderLayout('description', this.description);
            this.updateOrderLayout('height', this.height);
            this.updateOrderLayout('width', this.width);

            this.$refs.modal.$emit('hide');
        },

        updateOrderLayout(key, value) {
            this.setOrderLayoutAttribute({ key, value });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-edit-grid.vue